import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { ImageGalleryComponent } from 'src/app/components/shared/image-gallery/image-gallery.component';
import { EventResource } from 'src/app/interfaces/event-resource';
import { AttachmentService } from 'src/app/services/attachment.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';
import {
	AccessibilityHelp,
	Alignment,
	AutoLink,
	Autosave,
	BalloonToolbar,
	BlockQuote,
	Bold,
	Essentials,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	GeneralHtmlSupport,
	Heading,
	Highlight,
	HorizontalLine,
	Indent,
	IndentBlock,
	Italic,
	Link,
  List,
	Paragraph,
	RemoveFormat,
	SelectAll,
	SpecialCharacters,
	Strikethrough,
	Underline,
	Undo,
  ClassicEditor
} from 'ckeditor5';

import translations from 'ckeditor5/translations/de.js';
@Component({
  selector: 'app-advanced-details',
  templateUrl: './advanced-details.component.html',
  styleUrls: ['./advanced-details.component.scss']
})
export class AdvancedDetailsComponent implements OnInit {
    /**
   * The Array of Images to be uploaded
   */
  files: File[] = [];
  /**
   * The Array of Images to be uploaded
   */
  filesTertiaryImage: File[] = [];
  /**
   * The Form to add the Data
   */
  addForm: UntypedFormGroup;
    /**
   * has the Image changes
   */
  changeImage: boolean = false;
  /**
   * has the TertiaryImage changes
   */
  changeImageTertiaryImage: boolean = false;
  /**
   * The current Event => set via URL
   */
  currentEvent: EventResource;
  /**
   * Image Data
   */
  imageProperties = [
    { key: 'logo', value: null, hint: 'Format: 800 x 500, Typ: .png', hasChanged: false },
  ]
  public Editor = ClassicEditor;
  public config = {
    toolbar: {
      items: [
        'undo',
        'redo',
        '|',
        'heading',
        '|',
        'bold',
        'italic',
        'underline',
        'strikethrough',
        'fontColor',
        '|',
        'link',
        'alignment',
        '|',
        'bulletedList',
        'numberedList',
        'outdent',
        'indent'
      ],
      shouldNotGroupWhenFull: true
    },
    plugins: [
      AccessibilityHelp,
      Alignment,
      AutoLink,
      Autosave,
      BalloonToolbar,
      BlockQuote,
      Bold,
      Essentials,
      FontBackgroundColor,
      FontColor,
      FontFamily,
      FontSize,
      GeneralHtmlSupport,
      Heading,
      Highlight,
      HorizontalLine,
      Indent,
      IndentBlock,
      Italic,
      Link,
      Paragraph,
      RemoveFormat,
      SelectAll,
      SpecialCharacters,
      Strikethrough,
      Underline,
      Undo,
      List,
    ],
    heading: {
      options: [
        {
          model: 'paragraph',
          title: 'Paragraph',
          class: 'ck-heading_paragraph'
        },
        {
          model: 'heading1',
          view: 'h1',
          title: 'Überschrift 1',
          class: 'ck-heading_heading1'
        },
        {
          model: 'heading2',
          view: 'h2',
          title: 'Überschrift 2',
          class: 'ck-heading_heading2'
        },
        {
          model: 'heading3',
          view: 'h3',
          title: 'Überschrift 3',
          class: 'ck-heading_heading3'
        },   
        {
          model: 'heading4',
          view: 'h4',
          title: 'Überschrift 4',
          class: 'ck-heading_heading4'
        },               {
          model: 'heading5',
          view: 'h5',
          title: 'Überschrift 5',
          class: 'ck-heading_heading5'
        }, 
        {
          model: 'heading6',
          view: 'h6',
          title: 'Überschrift 6',
          class: 'ck-heading_heading6'
        },   
      ]
    },
    htmlSupport: {
      allow: [
        {
          name: /^.*$/,
          styles: true,
          attributes: true,
          classes: true
        }
      ]
    },
    language: 'de',
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file'
          }
        }
      }
    },
    placeholder: '',
    translations: [translations]
  }
  /**
   * constructor
   * Init the From
   * @param eventService 
   * @param fb 
   * @param environmentService 
   * @param dialog 
   * @param attachmentService 
   * @param overlayService 
   * @param router 
   * @param route 
   */
  constructor(
    private eventService: EventService,
    private fb: UntypedFormBuilder,
    private environmentService: EnvironmentService,
    private dialog: MatDialog,
    private attachmentService: AttachmentService,
    private overlayService: OverlayService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.addForm = this.fb.group({
      alternativeImage: ['', []],
      shortDescription: ['', []],
      tertiaryImage: ['', []],
      advancedDescription1: ['', []],
      advancedDescription2: ['', []],
      advancedReservationClue: ['', []],
    });
  }
  /***
   * ngOnInit
   * Get the current Event via the URL
   */
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.eventService.loadAdvancedEventProperties(params['id']).subscribe((event: EventResource) => {
        this.currentEvent = event;
        this.addForm.patchValue(this.currentEvent)
      })
    })
  }
  /**
   * Upload the selcted Image as an Attachment
   * @param event 
   */
  onSelect(event) {
    this.files.push(...event.addedFiles);
    if (this.files.length != 0) {
      this.attachmentService.createAttachment(this.environmentService.getClientId(), this.files[0]).subscribe(attachment => {
        this.addForm.patchValue({
          alternativeImage: attachment
        })
      })
    }
  }
  /**
   * Remove the Image from the Array
   * @param event 
   */
  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  /**
   * Upload the selcted Image as an Attachment
   * @param event 
   */
  onSelectTertiaryImage(event) {
    this.filesTertiaryImage.push(...event.addedFiles);
    if (this.filesTertiaryImage.length != 0) {
      this.attachmentService.createAttachment(this.environmentService.getClientId(), this.filesTertiaryImage[0]).subscribe(attachment => {
        this.addForm.patchValue({
          tertiaryImage: attachment
        })
      })
    }
  }
  /**
   * Remove the Image from the Array
   * @param event 
   */
  onRemoveTertiaryImage(event) {
    this.filesTertiaryImage.splice(this.filesTertiaryImage.indexOf(event), 1);
  }
  /**
   * Move back to the Event Page
   */
  movebacktoOverview() {
    this.router.navigateByUrl('caseworker/event')
  }
  /**
   * Save the Changes to the backend
   * @returns 
   */
  saveAdvancedDetails() {
    this.addForm.markAllAsTouched();
    if (this.addForm.invalid) {
      return
    }
    let tempEvent: EventResource;
    tempEvent = this.currentEvent;
    tempEvent.shortDescription = this.addForm.getRawValue().shortDescription,
      tempEvent.advancedDescription1 = this.addForm.getRawValue().advancedDescription1,
      tempEvent.advancedDescription2 = this.addForm.getRawValue().advancedDescription2,
      tempEvent.advancedReservationClue = this.addForm.getRawValue().advancedReservationClue,
      tempEvent.tertiaryImage = this.addForm.getRawValue().tertiaryImage,
      tempEvent.alternativeImage = this.addForm.getRawValue().alternativeImage,
      this.eventService.saveAdvancedEventProperties(this.currentEvent).subscribe({
        next: (res: EventResource) => {
          this.overlayService.openSnackBar("Weitere Angaben erfolgreich bearbeitet! ")
        },
        error: err => {
          console.log(err)
        }
      })
  }
  /**
   * Open The ImageGalleryComponent to let the user select an Image
   * @param property 
   * @param type 
   */
  openImageGallery(property, type: string) {
    const dialogRef = this.dialog.open(ImageGalleryComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (type == 'tertiaryImage') {
          this.addForm.patchValue({
            tertiaryImage: result
          })
        } else {
          this.addForm.patchValue({
            alternativeImage: result
          })
        }
        // property.value = result.url;
        // property.hasChanged = true;
        // property.newValue = `${result.clientRef}/attachment/${result.publicId}`;
      }
    });
  }
  /**
   * Show the Uploadfield for the Image
   */
  toogleImageUpload() {
    this.changeImage = !this.changeImage;
  }
  /**
   * Show the Uploadfield for the TertiaryImage
   */
  toogleImageUploadTertiaryImag() {
    this.changeImageTertiaryImage = !this.changeImageTertiaryImage;
  }
}
